module.exports = __webpack_public_path__ + "img/Avatar-2.c8d8887c.svg";